import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getActiveAudioSchemaFleet } from '../../services/AudioSchemaService';
import { AudioSchemaPerFleet } from '../../types/AudioSchemas';
import { FeaturesManagement } from '../../../featuresControl';

function useGetAudioSchemaFleet(fleetId: string): UseQueryResult<AudioSchemaPerFleet> {
  return useQuery(
    ['audio-schemas', fleetId],
    async (): Promise<AudioSchemaPerFleet> => getActiveAudioSchemaFleet(fleetId),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: true,
      enabled: fleetId !== '',
      refetchOnWindowFocus: false,
      // refetchInterval: FeaturesManagement.productivity.refetchInterval,
    },
  );
}

export default useGetAudioSchemaFleet;
